<div class="modal-content">
    <div class="modal-header text-center">

    </div>
    <div class="modal-body pb-5">
        <img src="assets/img/alert.svg">
        <h3 class="mt-2">¡Lo sentimos!</h3>
        <hr class="w-50 mx-auto">
        <h6 class="mt-2">Ha ocurrido un error de autenticación, pues</h6>
        <h6 class="mt-2">hay otro ejecutivo logueado en el escritorio</h6>
    </div>
    <div class="modal-footer">
        <div class="row mx-auto">
            <h6>Si de todas formas desea autenticarse, al confirmar será finalizada la sesión del otro ejecutivo y será ingresado en el escritorio indicado</h6>
        </div>
        <div class="row mx-auto">
            <div class="col-6">
                <button type="button" class="btn-conf" (click)="confirmar()">Confirmar</button>
            </div>
            <div class="col-6">
                <button type="button" class="btn-canc" (click)="cerrar()">Cancelar</button>
            </div>
        </div>

    </div>
</div>